import { defaultContactIdsByOrg } from '~/hooks/useContactSelection';
import type { OrganizationContactData } from '~/api/organizationContactData';
import type { SellerList } from '~/api/sellerLists';
import type { RecipientOrganization } from '~/utils/contact';
import type { SellerSelection } from './useSellerRecipients';

export function sellerListSelections(
  members: SellerList['members'],
  contactDataById: Map<string, OrganizationContactData>
): SellerSelection<RecipientOrganization>[] {
  const defaultIdsByOrg = defaultContactIdsByOrg(contactDataById);
  return members.map(({ seller, contacts: savedContacts }) => {
    const fetched = contactDataById.get(seller.id)?.sellerContacts ?? [];
    const fetchedIds = new Set(fetched.map((contact) => contact.id));
    const stillFetched = savedContacts.filter((contact) =>
      fetchedIds.has(contact.id)
    );
    const defaultIds = new Set(defaultIdsByOrg.get(seller.id));
    const contacts =
      stillFetched.length > 0
        ? stillFetched
        : fetched.filter((contact) => defaultIds.has(contact.id));
    return { organization: seller, contacts };
  });
}

export const sellerIds = (sellerList: SellerList) =>
  sellerList.members.map(({ seller }) => seller.id);
